import Text from "@ds/components/Text";
import { Box } from "@mui/material";
import ArrowDown from "@icons/mobile/ArrowDown";
import useStyles from "./styles";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Puller from "@pwa/Header/Puller";
import useActions from "../ContentMenuScroll/hooks/useActions";
import MenuList from "../MenuList";

export type SwipeableMenuProps = {
  selected: string;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onChange: (_item: string) => void;
  tableOfContents: string[];
  title?: string;
};

const SwipeableMenu: React.FC<SwipeableMenuProps> = ({
  selected,
  isOpen,
  onOpen,
  onClose,
  onChange,
  title,
  tableOfContents,
}) => {
  const classes = useStyles();
  const { isMobile, scrollToId, removeHtmlCode } = useActions({});

  const onClickMenuItem = (value: string) => {
    onChange(value);
    onClose();
  };

  return (
    <Box>
      <Box className={classes.drawerSelected} onClick={onOpen} mb={isMobile ? 0 : 2}>
        <Text
          data-testid="swipeable-menu-label"
          variant="body1"
          color="primary-main"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            wordBreak: "break-word",
          }}
        >
          {selected}
        </Text>
        <ArrowDown />
      </Box>
      <SwipeableDrawer
        anchor="bottom"
        open={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        classes={{ paper: classes.drawer }}
      >
        <Puller top={8} />
        {!!title && (
          <Box pb={2} className={classes.titleWrapper}>
            <Text variant="h3" weight="700">
              {title}
            </Text>
          </Box>
        )}
        <MenuList
          tableOfContents={tableOfContents}
          isMobile={isMobile}
          onClose={(e) => onClickMenuItem(e)}
          onScroll={(e) => scrollToId(e)}
          onIsActive={(e) => removeHtmlCode(e) === selected}
        />
      </SwipeableDrawer>
    </Box>
  );
};

export default SwipeableMenu;
